import React, { useMemo } from 'react';
import classNames from 'classnames';

import Icon from 'vibo-ui/Icon';
import Image from 'vibo-ui/Image';

import { ReactComponent as PlayBardsJumpingIcon } from 'resources/img/svg/playBardsJumping.svg';

import { useSongPlayBar } from 'components/context/SongPlayBarContext';
import {
  getSmallestAvailableThumbnail,
  getFormattedSongArtistAndTitle,
} from 'services/songs/helpers';

import { SongImageProps } from './interfaces';

import useStyles from './style';

const SongImage = <T extends SongData & { _id?: string }>({
  src,
  className,
  song,
  isLazy,
  onClick,
  label = null,
}: SongImageProps<T>) => {
  const classes = useStyles();

  const imageSrc = useMemo(() => getSmallestAvailableThumbnail(song?.thumbnails), [
    song?.thumbnails,
  ]);
  const alt = useMemo(() => getFormattedSongArtistAndTitle(song), [song?.title, song?.artist]);

  const playBar = useSongPlayBar();
  const track = playBar?.songData?.track;

  const isPlaying = !!track && (track?.viboSongId === song?.viboSongId || track?._id === song?._id);

  return useMemo(
    () => (
      <Image
        src={src || imageSrc}
        onClick={() => song && onClick?.(song)}
        alt={alt}
        className={classNames('songImage', classes.songImage, className, {
          isPlaying,
        })}
        gradientId={src || alt}
        isLazy={isLazy}
        label={
          isPlaying ? (
            <Icon icon={PlayBardsJumpingIcon} className="playIcon" disableAutoFontSize />
          ) : (
            label
          )
        }
      />
    ),
    [song?.thumbnails, isPlaying, onClick]
  );
};

export default SongImage;
